import type { QueryClient } from '@tanstack/react-query'

/** Root key for profile queries — partial match invalidates all users' profile caches. */
export const PROFILE_QUERY_ROOT = ['profile'] as const

export function profileQueryKey(userId: number | string | null | undefined) {
  return [...PROFILE_QUERY_ROOT, userId ?? 'anonymous'] as const
}

/** Drop all React Query data when the authenticated user session ends. */
export function clearUserSessionCache(queryClient: QueryClient): void {
  queryClient.clear()
}
